export default __webpack_public_path__ + "static/media/world-globe-particles.87c1b304.png";